import { Component } from '@angular/core';

@Component({
  selector: 'default-now-sell',
  templateUrl: './now-sell.component.html',
  styleUrls: []
})
export class DefaultNowSellComponent {
}
